import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import Vuex from 'vuex'
import store from './store/store';
Vue.use(Vuex)
Amplify.configure(awsconfig);
import '@aws-amplify/ui-vue';
Vue.config.productionTip = false


new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
